// extracted by mini-css-extract-plugin
export default {"goBackStyle":"_18849031c2ebc5c989d1ff3d509e581f"};